import React from 'react'
import { ConfigProvider } from 'antd'
import { Provider as StoreProvider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from './store/configureStore'
import { BrowserRouter } from 'react-router-dom'
import Router from './Router'
import './services/hotjar'
import './App.css'

function App (): JSX.Element {
  return (
    <StoreProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#cb101a'
            }
          }}>
          <BrowserRouter>
            <Router/>
          </BrowserRouter>
        </ConfigProvider>
      </PersistGate>
    </StoreProvider>
  )
}

export default App
